module.exports = __webpack_public_path__ + "6c4a0dbc/img/arrow-share-icon.00a12c29.svg";